import React from 'react'

import classnames from 'classnames'

import type { MenuRecipeImage } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { Carousel as SlickCarousel } from 'components/Carousel'

import { DetailImage } from '../DetailImage'
import { Arrow } from './Arrow'
import { ContentMask } from './ContentMask'

import css from './Carousel.css'

type CarouselImage = Pick<MenuRecipeImage, 'crops' | 'title' | 'description'>

type DetailCarouselProps = {
  images: CarouselImage[]
  dots?: boolean
  arrows?: boolean
}

export const DetailCarousel = ({
  images = [],
  dots = true,
  arrows = true,
}: DetailCarouselProps) => (
  <div className={css.carousel} data-testid="image-carousel">
    <SlickCarousel
      dots={dots}
      dotsClass={classnames(css.dots, css.darkDots)}
      arrows={arrows}
      prevArrow={<Arrow direction="left" />}
      nextArrow={<Arrow direction="right" />}
      infinite
      autoplaySpeed={5000}
      speed={200}
    >
      {images.map((image) => (
        <div className={css.slide} key={image.title || image.crops[0]?.url}>
          <ContentMask className={css.mask}>
            <p className={css.imageTitle}>{image.title}</p>
            <p className={css.imageDescription}>{image.description}</p>
          </ContentMask>
          <DetailImage media={image.crops} title={image.title} view="large" />
        </div>
      ))}
    </SlickCarousel>
  </div>
)
